export default "__VITE_ASSET__IVDc82bf__"